module.exports = __webpack_public_path__ + "img/about-photo.b837c201.png";